import { CheckRegimenIntegrationCode, CheckRegimenPmsCode, createRegimesConfig, editRegimesConfig, fetchLanguagesAvailables } from "../../../../../../../api/repositoryEP";
import { RegimesConfigCreateData, RegimesConfigData, TranslationData } from "../../../../../../../models/MappingData";
import { useEffect, useState } from "react";
import { Form, Row, Col, Button, Input, Checkbox, TabsProps, Divider, Tabs, Alert } from "antd";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import './RegimesForm.scss';
import { LoadingData } from "../../../../../../common";
import { set } from "lodash";

interface RegimesFormProps {
    drawerVisible: boolean;
    setDrawerVisible: (visible: boolean) => void;
    regimesData: RegimesConfigData | null;
    setRegimesData: (regimesData: RegimesConfigData | null) => void;
}

const RegimesForm = (props: RegimesFormProps): JSX.Element => {
    const [regimesName, setRegimesName] = useState<Array<TranslationData>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingLanguages, setLoadingLanguages] = useState<boolean>(false);
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const [codeValue, setCodeValue] = useState<string>("");
    const [integrationCodeValue, setIntegrationCodeValue] = useState<string>("");



    useEffect(() => {
        if (props.regimesData) {
            form.setFieldsValue({
                code: props.regimesData.code,
                integrationCode: props.regimesData.integrationCode,
                internalNote: props.regimesData.internNote,
            });
        }
        setCodeValue(props?.regimesData?.code || "");
        setIntegrationCodeValue(props?.regimesData?.integrationCode || "");
    }, [props.regimesData]);


    const closeDrawer = () => {
        props.setRegimesData(null);
        form.resetFields();
        props.setDrawerVisible(false);
    };

    const modifyRegimesName = (index: number, value: string) => {
        const newRegimesName = [...regimesName];
        newRegimesName[index].value = value;
        setRegimesName(newRegimesName);
    };

    const handleBtnCancel = () => {
        closeDrawer();
    };

    useEffect(() => {
        if (props.drawerVisible) {
            if (props.regimesData) {
                setRegimesName(props.regimesData.name);
            } else {
                setLoading(true); // Inicia la carga
                setLoadingLanguages(true)
                fetchLanguagesAvailables("wa").then((r) => {
                    if (r?.type === 1) {
                        const languages = r.data.map((lang: string) => ({
                            language: lang,
                            value: ''
                        }));
                        setRegimesName(languages);

                    } else {
                        props.setDrawerVisible(false);
                    }

                    setLoading(false); // Finaliza la carga
                    setLoadingLanguages(false);
                });
            }
        }
    }, [props.drawerVisible]);

    const handleSave = () => {
        setLoading(true); // Inicia la carga
        if (props.regimesData === null) { // CREATE
            const regimesData: RegimesConfigCreateData = {
                name: regimesName,
                code: codeValue,
                integrationCode: integrationCodeValue,
                internNote: form.getFieldValue("internalNote"),
            };

            createRegimesConfig(regimesData).then((response) => {
                if (response?.type === 1) {
                    closeDrawer();
                }
                setLoading(false); // Finaliza la carga
            });

        } else { // EDIT
            const regimesData: RegimesConfigData = {
                id: props.regimesData?.id,
                name: regimesName,
                code: codeValue,
                integrationCode: integrationCodeValue,
                internNote: form.getFieldValue("internalNote"),

            };

            editRegimesConfig(regimesData).then((response) => {
                if (response?.type === 1) {
                    closeDrawer();
                }
                setLoading(false); // Finaliza la carga
            });
        }
    };

    const handleChangeCode = (e: any) => {
        setCodeValue(e.target.value);
    };

    const handleChangeIntegrationCode = (e: any) => {
        setIntegrationCodeValue(e.target.value);
    };


    const mappingItems: TabsProps['items'] = [
        {
            key: '1',
            label: `${t("components.tab-mapping.title-pms")}`,
            children: <Row gutter={16}>
                <Col xs={24} md={24}>
                    <Form.Item
                        name="code"
                        label={t("components.tab-mapping.room-config.drawer.code-in-pms")}
                        initialValue={props.regimesData?.code}
                        rules={[
                            {
                                required: true,
                                message: t("components.tab-mapping.room-config.drawer.code-required") + ""
                            },
                        ]}
                    >
                        <Input className="app-input"
                            value={codeValue}
                            onChange={handleChangeCode}

                        />

                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.pms-codes-explanation")}
                    </small>
                </Col>
            </Row>,
        },
        {
            key: '2',
            label: `${t("components.tab-mapping.title-integrations")}`,
            children: <Row gutter={16}>
                <Col xs={24}>
                    <Form.Item
                        name="integrationCode"
                        label={t("components.tab-mapping.regimes-config.drawer.code-in-integrations")}
                        initialValue={props.regimesData?.integrationCode}
                        rules={[
                            {
                                required: true,
                                message: t("components.tab-mapping.room-config.drawer.code-required") + ""
                            },
                        ]}
                    >
                        <Input className="app-input"
                            value={integrationCodeValue}
                            onChange={handleChangeIntegrationCode}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.integration-codes-explanation")}
                    </small>
                </Col>
            </Row>,
        }
    ];

    return (
        <div>
            {loadingLanguages ? (
                <div className="loading-data">
                    <LoadingData />
                </div>
            ) : (
                <Form
                    form={form}
                    className='regimes-form-component'
                    onFinish={handleSave}
                    layout="vertical"
                >
                    <Row gutter={16}>
                        <Col xs={24} md={24}>
                            <Form.Item
                                label={t("components.tab-mapping.regimes-config.drawer.name")}
                                name="names"
                                required
                                validateStatus={regimesName.some(opt => !opt.value.trim()) ? "error" : ""}
                                help={
                                    regimesName.some(opt => !opt.value.trim())
                                        ? t("components.tab-mapping.regimes-config.drawer.name-required")
                                        : ""
                                }
                            >
                                {regimesName.map((item, optIndex) => (
                                    <div key={optIndex} className="names-input-container">
                                        <span>{item.language.toUpperCase().substring(item.language.length - 2)}</span>
                                        <Input
                                            value={item.value}
                                            onChange={(e) => modifyRegimesName(optIndex, e.target.value)}
                                            className="input" />
                                    </div>
                                ))}
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="internalNote"
                                label={t("components.tab-mapping.regimes-config.drawer.internal-note")}
                                initialValue={props.regimesData?.internNote}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>

                        <Divider>
                            {t("components.tab-mapping.title-mapping-code")}
                        </Divider>
                        <Col xs={24} md={24}>
                            <Tabs defaultActiveKey="1" items={mappingItems} />
                        </Col>


                        <Col xs={24} md={24} style={{ marginTop: 40 }}>

                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item >
                                <Button className="app-white-button width-95" onClick={handleBtnCancel}>
                                    {t("components.button.cancel")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item >
                                <Button
                                    className="app-button width-95"
                                    htmlType="submit"
                                    loading={loading}
                                    disabled={loading || codeValue?.length === 0 || integrationCodeValue?.length === 0 || regimesName.some(option => !option.value.trim())}  // <-- bloquea mientras valida
                                >
                                    {t("components.button.save")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>)}
        </div>
    );
};

export default RegimesForm;